import React, { useEffect } from 'react';

// Router
import Router from './routes';

// Component
import AuthProvider from '@contexts/Auth/AuthProvider';
import ScrollToTop from '@components/ScrollToTop';
import { SettingsProvider } from '@contexts/Setting/SettingsContext';
import Theme from '@theme/Theme';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactNotifications } from 'react-notifications-component';
import ChatBot from '@components/ChatBot/ChatBot';
import { ConfigProvider } from 'antd';
import 'react-notifications-component/dist/theme.css';
import 'react-image-gallery/styles/css/image-gallery.css';
import 'assets/css/override.css';
import 'swiper/css';
import 'swiper/css/navigation';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      cacheTime: 0
    }
  }
});

function App() {
  return (
    <ConfigProvider theme={{ token: { borderRadius: 0 } }}>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <ScrollToTop />
          <SettingsProvider>
            <Theme>
              <ReactNotifications />
              <Router />
              <ChatBot />
            </Theme>
          </SettingsProvider>
        </QueryClientProvider>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
